export const MAX_CARTON_COUNT = 9999;

export function matchesProduct(row, searchText) {
  const query = searchText.trim().toLowerCase();
  return (
    !query ||
    row.itemNumber.toLowerCase().includes(query) ||
    row.productName.toLowerCase().includes(query)
  );
}

export function getCartonCount(row) {
  const qty = Number(row.qty);
  const qtyPerCarton = Number(row.qtyPerCarton);
  return qtyPerCarton > 0 && qty % qtyPerCarton === 0
    ? qty / qtyPerCarton
    : null;
}

export function getCbm(row, cartonCount) {
  return Number((Number(row.cbm || 0) * cartonCount).toFixed(3));
}
